export default {
  SET_VENDOR_LIST(state, val) {
    state.vendors = val
  },
  SET_EXPENSES_TABLE_LIST(state, val) {
    state.expensesTableList = val
  },
  UPDATE_EXPENSES_TABLE_LIST(state, val) {
    state.expensesTableList.push(...val)
  },
  SET_REJECTED_BOOL(state, val) {
    state.rejected = val
  },
  SET_PENDING_BOOL(state, val) {
    state.pending = val
  },
  SET_INVOICED_BOOL(state, val) {
    state.invoiced = val
  },
  
  SET_CLIENT_LIST(state, val) {
    state.vendors = [...val]
  },
  UPDATE_ACCOUNTING(state, expense) {
    const i = state.expensesTableList.findIndex((e) => e.ExpenseId === expense.ExpenseId)
    Object.assign(state.expensesTableList[i], expense)
  },
  //TAX
  CLEAR_TAX_TABLE_LIST(state) {
    state.taxTableList = []
  },
  SET_TAX_TABLE_LIST(state, val) {
    state.taxTableList = val
  },
  UPDATE_TAX_TABLE_LIST(state, val) {
    state.taxTableList.push(...val)
  },
  ADD_TAX(state, tax) {
    state.taxTableList.unshift(tax)
  },
  UPDATE_TAX(state, tax) {
    const i = state.taxTableList.findIndex(i => i.id === tax.id)
    Object.assign(state.taxTableList[i], tax)
  }
}
